import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';
import {afterEachRoute, pageRedirect, scrollToTop} from "@helpers/router-helper";
import {useAuthStore} from '@store';

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    routes,
    scrollBehavior: scrollToTop
});

router.beforeEach(async (to, from, next) => {
    let path = window.location.pathname,
        unknownRoute = router.resolve(path)?.route?.name === 'not-found' && path.indexOf('not-found') === -1,
        notRedirected = window.location.href.indexOf('forceRedirect') === -1,
        redirected = false;

    if (unknownRoute && notRedirected) {
        const storeAuth = useAuthStore();

        if (storeAuth?.me?.uuid) {
            //For logged users try to redirect to the specific (seller / agent / broker) module
            //in case the route will not be found there it will return directly to 'not-found' route
            let search = (window.location.search ? '&' : '?') + 'forceRedirect=1';
            await pageRedirect(window.location.href + search);
            redirected = true;
        } else {
            //redirect to log in
            if (
                window.location.pathname.indexOf('/auth') === -1 &&
                Boolean(window.location.pathname.match(/\/(?:dashboard|profile|link\-account|orders\/)/g))
            ) {
                await pageRedirect(window.env.APP_URL + '/auth?redirectUrl=' + window.location.href );
                redirected = true;
            }
        }
    }
    if (!redirected) {
        return next();
    }
});
router.afterEach(afterEachRoute);

export default router;
